// components/Footer.jsx

import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import FooterHero from "./footer/FooterHero";

export default function Footer() {
  return (
    <>
      {/* New Fluence-style footer section */}
      <FooterHero
        brand={{ 
          name: "EPC Spark", 
          tagline: "Spark your EPC workflow", 
          logoSrc: "/epc-spark-symbol-only.png", 
          logoAlt: "EPC Spark" 
        }}
        useLinks={[
          { label: "Feature", href: "#features" },
          { label: "About", href: "/about" },
          { label: "Testimonial", href: "#testimonials" },
          { label: "Pricing", href: "#pricing" },
          { label: "Contact", href: "/contact" },
          { label: "Blog", href: "#blog" },
        ]}
        addressLines={["128 City Road, London, EC1V 2NX", "United Kingdom"]}
        socials={[
          { kind: "x", href: "https://x.com/EpcSpark", label: "X (Twitter)" },
          { kind: "instagram", href: "https://www.instagram.com/epc.sparkofficial/", label: "Instagram" },
          { kind: "linkedin", href: "https://www.linkedin.com/company/epc-spark/about/?viewAsMember=true", label: "LinkedIn" },
        ]}
      />

      {/* Legal bar only */}
      <footer className="footer position-relative py-3 text-white bg-dark">
        <Container>
          <div className="footer-bottom text-center">
            <div className="footer-links mb-2">
              <Link to="/privacypolicy">Privacy Policy</Link>
              <span className="footer-divider">|</span>
              <Link to="/footer-terms-and-conditions">Terms & Conditions</Link>
              <span className="footer-divider">|</span>
              <a href="#">Cookie Policy</a>
            </div>
            <div className="text-muted small" style={{ color: '#111' }}>&copy; EPC Spark 2025</div>
          </div>
        </Container>
      </footer>
    </>
  );
}
